import type { ReactNode } from "react";
import React, { createContext, useContext } from "react";

import type { RouteMatcher } from "./routeMatcher";
import { createRouteMatcher } from "./routeMatcher";

export interface RoutesProviderProps {
  routeMatcher: RouteMatcher;
  children: ReactNode;
}

const RouteMatcherContext = createContext<RouteMatcher>(createRouteMatcher([]));

export const useRouteMatcher = () => useContext(RouteMatcherContext);

export const RoutesProvider = ({
  routeMatcher,
  children,
}: RoutesProviderProps) => (
  <RouteMatcherContext.Provider value={routeMatcher}>
    {children}
  </RouteMatcherContext.Provider>
);
